import { OAUTH_PROVIDERS_OBJECT } from 'constants-user';

export function redirectTo(provider: any) {
  return `${window.location.origin}/redirect/${provider}`;
}

export const { MICROSOFT, LINKEDIN, GOOGLE } = OAUTH_PROVIDERS_OBJECT;
